import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import { useEffect, useRef, useState } from "react";
import YouTube from "react-youtube";
import Modal from "./modal";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";

export default function GalleryModal(props) {
    const [tabState, setTabState] = useState('image')
    const splideRef = useRef(null);
    const youtubeRef = useRef(null);
    const childRef = useRef(null);
    const splidePaginationRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState('');
    const [galleryImageData, setGalleryImageData] = props.galleryImageData ? useState(props.galleryImageData) : useState([]);
    const [galleryRotatingImageData, setGalleryRotatingImageData] = useState(props.galleryRotatingImageData);
    props = {...props, setTabState}

    function showGalleryModal(showModal, tab) {
        childRef.current.showModal(showModal);
        if (!showModal) {
            setTabState('image');
        } else {
            setTabState(tab);
        }
    }

    window.showGalleryModal = showGalleryModal;

    useEffect(() => {
        let tempGalleryImageData = JSON.parse(JSON.stringify(galleryImageData));
        tempGalleryImageData[0].selected = true;
        setGalleryImageData(tempGalleryImageData);
        if (galleryRotatingImageData) {
            let tempGalleryRotatingImageData = JSON.parse(JSON.stringify(galleryRotatingImageData));
            tempGalleryRotatingImageData[0].selected = true;
            setGalleryRotatingImageData(tempGalleryRotatingImageData);
        }
    },[]);

    useEffect(() => {
        if (tabState !== 'video' && youtubeRef.current.internalPlayer.pauseVideo) {
            youtubeRef.current.internalPlayer.pauseVideo();
        }
    },[tabState]);

    useEffect(() => {
        let items = splideRef.current.splide.Components.Pagination.items;
        splidePaginationRef.current.textContent = 1 + ' of ' + items.length;

        splideRef.current.splide.event.on( 'move', function ( data ) {
            splidePaginationRef.current.textContent = data + 1 + ' of ' + items.length;

        });

        splideRef.current.splide.root.style.margin = '0 auto';

        function handleResize () {
            if (window.matchMedia("(max-height: 850px)").matches) {
                splideRef.current.splide.root.style.maxWidth = (665-(850-window.innerHeight))+'px';
            } else {
                splideRef.current.splide.root.style.maxWidth = '';
            }
        }

        window.addEventListener("resize", handleResize);

        handleResize();
    },[splideRef]);

    return (
        <>
            <Modal ref={childRef} {...props}>
                <div className='top-bar'>
                    <div className='top-menu'>
                        <div className='menu'>
                            <div className='item' onClick={()=>{setTabState('image')}}>
                                Product Images
                                <div className={'item-underline' + (tabState === 'image' ? ' red' : '')}></div>
                            </div>
                            <div className='item' onClick={()=>{setTabState('video')}} style={{display: props.yt_video_id ? 'block' : 'none'}}>
                                Product Video
                                <div className={'item-underline' + (tabState === 'video' ? ' red' : '')}></div>
                            </div>
                            {galleryRotatingImageData?.length > 0 && <div className='item' onClick={()=>{setTabState('rotate')}}>
                                3D Image
                                <div className={'item-underline' + (tabState === 'rotate' ? ' red' : '')}></div>
                            </div>}
                        </div>
                        <div id='close' onClick={() => {showGalleryModal(false, tabState)}}>
                            <div>X</div>
                        </div>
                    </div>
                </div>
                <div className={tabState === 'image' ? 'gallery-modal d-block' : 'gallery-modal'}>
                    <div id='image-gallery-tab' className='image-gallery' style={{display: tabState === 'image' ? 'flex' : 'none'}}>
                        <div className='image-grid-container'>
                            <div className='image-grid'>
                                {galleryImageData.map(function(image, i){
                                    return <img src={image.image[0]} data-image-id={image.id} data-id={i} onClick={setGalleryImage} style={image.selected ? {border: 'solid 2px #e3173e'} : {}} loading="lazy"/>;
                                })}
                            </div>
                        </div>
                        <div id='modal-image-container' className='image-container'>
                            <Splide hasTrack={ false } ref={ splideRef } aria-label="Image Gallery" options={{
                                rewind: true,
                                gap   : '1rem',
                            }} onMoved={(newIndex, destIndex, prevIndex) => {
                                updateSelectedImage(galleryImageData[destIndex].id);
                            }}>
                                <SplideTrack>
                                    {galleryImageData.map(function(image){
                                        return( 
                                            <SplideSlide>
                                                <button type="button" data-current-image={image.fullImage[0]} onClick={(e) => {setOpen(true); setCurrentImage(e.target.dataset.currentImage);}}><div className="expand-icon"></div></button>
                                                <img src={image.fullImage[0]} alt={image.caption} loading="lazy" />
                                                <p>{image.caption}</p>
                                            </SplideSlide>
                                        );
                                    })}
                                </SplideTrack>
                                <div className='splide-pagination' ref={splidePaginationRef}>hi</div>
                            </Splide>
                        </div>
                    </div>
                    <div id='video-tab' className='video' style={{display: tabState === 'video' ? 'block' : 'none'}}>
                        <YouTube className="yt-video-container" ref={youtubeRef} videoId={props.yt_video_id}/>
                        <div id="player"></div>
                    </div>
                    {galleryRotatingImageData?.length > 0 && <div id='rotate-tab' className='rotate image-gallery' style={{display: tabState === 'rotate' ? 'flex' : 'none'}}>
                        <div className={(galleryRotatingImageData?.length >= 1) ? 'image-grid-container' :  'image-grid-container d-none'}>
                            <div className='image-grid single-row'>
                                {galleryRotatingImageData?.map(function(image, i){
                                    return <img src={'/wp-content/uploads/' + image.rotating_image + '/0_0.jpg'} data-image-id={image.rotating_image} data-id={i} onClick={setRotatingGalleryImage} style={image.selected ? {border: 'solid 2px #e3173e'} : {}} loading="lazy"/>;
                                })}
                            </div>
                        </div>
                        <div id='modal-image-container' className='image-container'>
                            <button className={(galleryRotatingImageData?.length >= 1) ? 'arrow-button' :  'arrow-button d-none'} onClick={rotatingImageNext}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>
                            </button>
                            <button className={(galleryRotatingImageData?.length >= 1) ? 'arrow-button left' :  'arrow-button left d-none'} onClick={rotatingImagePrev}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>
                            </button>
                            <div id="KeyShotXR2" ref={(e) => {e && (e.innerHTML=""); initKeyShotXR("KeyShotXR2");}}></div>
                        </div>
                    </div>}
                </div>
            </Modal>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                render={{
                    iconPrev: () => null,
                    iconNext: () => null,
                }}
                plugins={[Zoom]}
                zoom={{maxZoomPixelRatio: 3}}
                slides={[
                    {
                        src: currentImage,
                    },
                ]}
            />
        </>
    );

    function updateSelectedImage(imageId) {
        let updated = props.galleryImageData.map((image) => {
            if (image.id == imageId) {
                return Object.assign({}, image, {
                    selected: true
                });
            }
            return image;
        });
        setGalleryImageData(updated);
    }

    function setGalleryImage(image) {
        updateSelectedImage(image.currentTarget.dataset.imageId);
        let imageId = parseInt(image.currentTarget.dataset.id);
        splideRef.current.splide.go(imageId);
    }

    function updateSelectedRotatingImage(imageId) {
        let updated = props.galleryRotatingImageData.map((image, i) => {
            if (i == imageId) {
                return Object.assign({}, image, {
                    selected: true
                });
            }
            return image;
        });
        setGalleryRotatingImageData(updated);
    }

    function setRotatingGalleryImage(image) {
        updateSelectedRotatingImage(image.currentTarget.dataset.id);
    }

    function rotatingImagePrev() {
        let currentIndex = galleryRotatingImageData.findIndex((item) => item.selected == true);
        let newIndex = currentIndex - 1;
        if (newIndex < 0) {
            newIndex = galleryRotatingImageData.length + newIndex;
        }
        updateSelectedRotatingImage(newIndex);
    }

    function rotatingImageNext() {
        let currentIndex = galleryRotatingImageData.findIndex((item) => item.selected == true);
        let newIndex = currentIndex + 1;
        if (newIndex >= galleryRotatingImageData.length) {
            newIndex = 0;
        }
        updateSelectedRotatingImage(newIndex);
    }
}
